<template>
  <div class="symptom-list">
    <div
      v-for="symptom in filteredList()"
      :key="symptom.id"
      @click="selectSymptom(symptom)"
      class="symptom-list__symptom-item"
    >
      <p-checkbox :value="symptom" v-model="selected1" />
      {{ symptom.name }}
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";

export default {
  name: "RecountTreesDamagePickerSymptomList",

  props: {
    selectedSymptoms: Array,
    searchValue: String,
  },
  data: () => ({
   
  }),

  created() {
    console.log("search: ", this.searchValue);
  },

  computed: {
    selected1: {
      get() {return this.selectedSymptoms},
      set(value) {this.$emit('update:selectedSymptoms', value)}

    },
    // filteredList() {
    //   return this.symptomList.filter((item) => {
    //     return item.name.toLowerCase().includes(this.searchValue.toLowerCase());
    //   });
    // },
    ...mapState("recount", {
      symptomList: (state) => state.trees.damageSymptomList,
    }),
  },

  methods: {
    filteredList() {
      return this.symptomList.filter((item) => {
        return item.name.toLowerCase().includes(this.searchValue.toLowerCase());
      });
    },
    selectSymptom(symptom) {
      this.$emit("select-symptom", symptom);
    },
  },
};
</script>

<style scoped>
.symptom-list {
  padding: 0 0.5rem;
}

.symptom-list__symptom-item {
  margin-bottom: 0.5rem;
  display: flex;
  gap: 0.5rem;
  /* align-items: center; */
}
</style>
